import type { Locale, MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"
import type { ApiRoute, NoBody } from "../api"

export interface GetMarketExportViewPathParams {
	marketplaceKey: MarketplaceKey
}

export interface GetMarketExportViewQueryParams {
	locale: Locale
}

export interface MarketExportView {
	disclaimer: string
	// Marketplace rollout flag plus the caller's roles and market restriction (e.g. AT), which only the BFF can read
	// from the JWT. The BFF and API enforce the same rule, this just hides an export that would be rejected.
	isDeliveredExportAvailable: boolean
	// The marketplace rollout flag of the in-stock export, which can be enabled independently of the delivered export.
	isInventoryExportAvailable: boolean
	locales: Locale[]
}

export const getMarketExportViewRoute: ApiRoute<
	GetMarketExportViewPathParams,
	GetMarketExportViewQueryParams,
	NoBody,
	MarketExportView | null
> = {
	buildUrl: (params) => `/dealerships/market-export/${params.marketplaceKey}`,
	method: "get",
	path: "/dealerships/market-export/:marketplaceKey",
}
